import { FormMultiselect as FormMultiselectDS } from '@gov-design-system-ce/react-form';
import { type FormMultiselectProps as FormMultiselectPropsDS } from '@gov-design-system-ce/react-form';
import { MessageWrapper } from './MessageWrapper';

export type FormMultiselectProps = Omit<
	FormMultiselectPropsDS,
	'messageWrapper' | 'classNames'
>;

export const FormMultiselect = ({ ...props }: FormMultiselectProps) => (
	<FormMultiselectDS
		{...props}
		label={{ size: 'm', ...props.label }}
		field={{ size: 'm', ...props.field }}
		messages={props.messages ?? { messages: [] }}
		messageWrapper={MessageWrapper}
	/>
);
